var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-team__skeleton-wrapper"},_vm._l((_vm.colCount),function(col){return _c('p',{key:col,staticClass:"ajax__line ajax__line-table-text user-team__skeleton"})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }